module.exports = __webpack_public_path__ + "img/3.c52a4483.png";